export const savedRecipes = [
  {
    id: 2,
    userId: 134,
    recipeId: 'recipe_cob3s45trqkc6',
    createdAt: '2021-12-03T06:25:02.420Z',
    updatedAt: '2021-12-03T06:25:02.420Z',
  },
  {
    id: 8,
    userId: 134,
    recipeId: 'recipe_k7m1t5esr6010',
    createdAt: '2021-12-03T06:26:04.243Z',
    updatedAt: '2021-12-03T06:26:04.243Z',
  },
];
